import { render, staticRenderFns } from "./gameCenterConfig.vue?vue&type=template&id=6b207610&"
import script from "./gameCenterConfig.vue?vue&type=script&lang=js&"
export * from "./gameCenterConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b207610')) {
      api.createRecord('6b207610', component.options)
    } else {
      api.reload('6b207610', component.options)
    }
    module.hot.accept("./gameCenterConfig.vue?vue&type=template&id=6b207610&", function () {
      api.rerender('6b207610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/app/gameCenterConfig/gameCenterConfig.vue"
export default component.exports